import moment from "moment";

export function createDatewithTime(date) {
  return moment(date).format("h:mm a, Do MMM YYYY");
}
